module.exports = __webpack_public_path__ + "img/mcclungs-logo.0ab61869.jpg";